export default __webpack_public_path__ + "static/media/Resolucion_7_acta_78.77387a50.pdf";